import { type TaskType, TaskTypeValues } from "@remi/enums/task-type";
import { fromEntries } from "@remi/ts-utils";

import { type ResponsibleParty, ResponsiblePartyValues } from "./blocking-task-responsible-party";
import {
  type BlockingTaskType,
  BlockingTaskTypeValues,
  type ManualBlockingTaskType,
  ManualBlockingTaskTypeValues,
} from "./blocking-task-type";
import { DEFINITIONS_BY_TYPE } from "./task-type-definitions";

export const BlockingTaskDescriptions: Record<ManualBlockingTaskType, string> = fromEntries(
  ManualBlockingTaskTypeValues.map((taskType) => [taskType, DEFINITIONS_BY_TYPE[taskType].manualDescription] as const),
);

export const BlockingTaskResponsibleParty: Record<BlockingTaskType, ResponsibleParty> = fromEntries(
  BlockingTaskTypeValues.map((taskType) => [taskType, DEFINITIONS_BY_TYPE[taskType].responsibleParty] as const),
);

export const ResponsiblePartiesBlockingTasks: Record<ResponsibleParty, BlockingTaskType[]> = fromEntries(
  ResponsiblePartyValues.map(
    (party) =>
      [party, BlockingTaskTypeValues.filter((taskType) => BlockingTaskResponsibleParty[taskType] === party)] as const,
  ),
);

/**
 * Configuration map defining which task types should be blocked by default for specific blocking tasks.
 * If a blocking task type is not in this map, no specific task type will be blocked (null).
 */
export const BlockingTaskDefaultBlockedTypes: Partial<Record<BlockingTaskType, TaskType>> = {
  NON_REMI_ROOF_WORK_SCHEDULED: "INSTALL_SCHEDULED",
  SUNRUN_FINDINGS_SUBMISSION_BLOCKED: "SUNRUN_SUBMIT_FINDINGS",
  SUNRUN_FINDINGS_REJECTED: "SUNRUN_FINDINGS_APPROVED",
  SUNRUN_INVOICE_REJECTED: "SUNRUN_INVOICE_APPROVED",
  SUNRUN_WORK_ORDER_REJECTED: "SUNRUN_WORK_ORDER_APPROVED",
  SUNRUN_WORK_ORDER_REJECTED_QA: "SUNRUN_WORK_ORDER_APPROVED",
  SUNRUN_FINDINGS_STALLED_IN_REVIEW: "SUNRUN_FINDINGS_APPROVED",
  SUNRUN_INVOICE_STALLED_IN_REVIEW: "SUNRUN_INVOICE_APPROVED",
  SUNRUN_INVOICE_APPROVED_NOT_PAID: "INVOICE_PAID",
  SUNRUN_PAID_INVOICE_OUTSTANDING: "INVOICE_PAID",
  AWAITING_HOMEOWNER_COLOR_SELECTION: "CREATE_WORK_ORDER",
};

export const TaskTypeContractorVisibleAsBlocker: Record<TaskType, boolean> = fromEntries(
  TaskTypeValues.map(
    (taskType) => [taskType, DEFINITIONS_BY_TYPE[taskType].contractorVisibleAsBlocker ?? false] as const,
  ),
);
